// import { ImageConverter, DebugLogger } from "saiten-base";
import { ExifParserFactory } from 'ts-exif-parser'
import { ExifData } from 'ts-exif-parser/lib/ExifData'
import ImageConverter from './ImageConverter'
import platform from 'platform'

export class ImageExifUtil {
  public static async getRotatedImageByExif(
    file: File
  ): Promise<HTMLCanvasElement> {
    const img = await ImageConverter.file2base64url(file)

    try {
      if (this.rotate_necesary()) {
        const exif = await this.getExif(file)
        const orient = exif.tags?.Orientation
          ? parseInt(exif.tags.Orientation)
          : 1
        const promise = new Promise<HTMLCanvasElement>((resolve, reject) => {
          this.resetOrientation(file, orient, (newImge: HTMLCanvasElement) =>
            resolve(newImge)
          )
        })
        return promise
      } else {
        return await ImageConverter.url2canvas(img)
      }
    } catch (ex) {
      console.error(ex)
      return await ImageConverter.url2canvas(img)
    }
  }

  public static rotate_necesary() {
    if (!platform.os || !platform.os.version) {
      return false
    }
    if (platform.os.family == 'iOS' && parseFloat(platform.os.version) < 13.4)
      return true
    else if (
      platform.os.family == 'OS X' &&
      platform.name == 'Safari' &&
      parseFloat(platform.os.version) < 10.16
    )
      return true
    else return false
  }
  // exifを取得する
  public static async getExif(file: File) {
    const fr = new FileReader()
    const promise = new Promise<ExifData>((resolve, reject) => {
      fr.onload = (evt: any) => {
        const ab = evt.target!.result as ArrayBuffer
        // console.log(ab);
        const buf = new Buffer(ab.byteLength)
        const view = new Uint8Array(ab)
        for (let i = 0; i < buf.length; ++i) {
          buf[i] = view[i]
        }
        const exif = ExifParserFactory.create(buf).parse()
        resolve(exif)
      }
    })
    fr.readAsArrayBuffer(file)
    return promise
  }

  private static resetOrientation(
    file: File,
    srcOrientation: number,
    callback: (canvas: HTMLCanvasElement) => void
  ) {
    const img = new Image()

    img.onload = () => {
      const width = img.width
      const height = img.height
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')!

      // set proper canvas dimensions before transform & export
      if (4 < srcOrientation && srcOrientation < 9) {
        canvas.width = height
        canvas.height = width
      } else {
        canvas.width = width
        canvas.height = height
      }

      // transform context before drawing image
      switch (srcOrientation) {
        case 2:
          // 左右の鏡像
          ctx.transform(-1, 0, 0, 1, width, 0)
          break
        case 3:
          // 180度回転する
          ctx.transform(-1, 0, 0, -1, width, height)
          break
        case 4:
          // 3+鏡像
          ctx.transform(1, 0, 0, -1, 0, height)
          break
        case 5:
          // 6+鏡像
          ctx.transform(0, 1, 1, 0, 0, 0)
          break
        case 6:
          // 右に90度回転する Androidの場合のみ、逆
          ctx.transform(0, 1, -1, 0, height, 0)
          break
        case 7:
          // 8+鏡像
          ctx.transform(0, -1, -1, 0, height, width)
          break
        case 8:
          // 右に270度回転する
          ctx.transform(0, -1, 1, 0, 0, width)
          break
        default:
          break
      }

      // draw image
      ctx.drawImage(img, 0, 0)

      // export base64
      console.log('rotate completed')
      callback(canvas)
    }

    const reader = new FileReader()
    reader.onload = () => {
      const dataUrl = reader.result
      console.log('dataUrl loaded')
      img.src = dataUrl as string
    }
    reader.readAsDataURL(file)
  }
}
